/**
 * "Is someone signed in in this browser?" for routing decisions on an
 * institute's own domain (TenantRouteGuard, TenantWebsite).
 *
 * Reads storage directly, as the login page does (checkTokenValidity).
 * tokenService loads storage only when the page loads, and sign-in writes
 * these keys straight to localStorage — so right after signing in, the guard
 * saw "signed out" and sent the user back to /login, whose own check saw
 * "signed in" and sent them on: an endless loop (hundreds of /auth/contexts/
 * calls) until a reload. A refresh token alone counts: the login page renews
 * it the same way.
 */
import { tokenService } from '@/services/tokenService';

export const isSignedInHere = (): boolean => {
  try {
    if (tokenService.isAuthenticated() || localStorage.getItem('isAuthenticated') === 'true') return true;
    return !!(localStorage.getItem('access_token') || localStorage.getItem('refresh_token'));
  } catch {
    return false;
  }
};
